export default __webpack_public_path__ + "static/media/lark.5f56668f5ecc8055681dccede4194884.svg";